<script setup lang="ts">
import type { ApiError } from '../api/http'
import { useErrorText } from '../lib/form'

defineProps<{ error: ApiError | null }>()
const text = useErrorText()
</script>

<template>
  <div v-if="error" class="banner" role="alert">
    <p>{{ text(error) }}</p>
    <p v-if="error.requestId" class="rid small">{{ $t('common.requestId') }}: <span class="mono">{{ error.requestId }}</span></p>
  </div>
</template>

<style scoped>
.banner {
  border: 1px solid var(--loss);
  border-left-width: 4px;
  border-radius: var(--radius-sm);
  padding: 0.65rem 0.9rem;
  color: var(--loss);
  background: rgb(var(--loss-rgb) / 0.06);
}
.rid {
  color: var(--fg-muted);
  margin-top: 0.15rem;
}
</style>
